import { useState, useEffect } from "react";
import { DataTablePFSEvent } from "primereact/datatable";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 25;

const PAGE_SIZE_OPTIONS = new Set([25, 50, 75, 100]);

export const useTablePagination = ({
  totalPages,
}: {
  totalPages?: number;
} = {}) => {
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);

  useEffect(() => {
    if (totalPages !== undefined && totalPages > 0 && page > totalPages) {
      setPage(totalPages);
    }
  }, [totalPages, page]);

  const fetchPage = (newPage: number) => setPage(newPage);

  const updatePageSize = (newPageSize: number) => {
    if (PAGE_SIZE_OPTIONS.has(newPageSize)) {
      setPageSize(newPageSize);
      setPage(DEFAULT_PAGE);
    }
  };

  const paginationProps = (totalPagesArg?: number, totalRecords?: number) => ({
    numberOfRowsPerPage: pageSize,
    firstPage: (Math.min(page, totalPagesArg ?? page) - 1) * pageSize,
    lazy: true,
    totalRecords,
    onPage: (e: DataTablePFSEvent) => {
      if (e.rows === pageSize) {
        fetchPage(e.page + 1);
      } else {
        updatePageSize(e.rows);
      }
    },
  });

  return { page, pageSize, fetchPage, updatePageSize, paginationProps };
};
